import Vue from "vue";
import SvgIcon from "@/components/VSvgIcon"; // svg component

// register globally
Vue.component("v-svg-icon", SvgIcon);

const req = require.context("@/assets/svg", false, /\.svg$/);
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);